import React from 'react';
import { Container } from "@mui/material";

const Home: React.FC = () => {
    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <h2>Not Found 404</h2>
        </Container>
    );
};

export default Home;
